import {CableCoreModel} from './cable-core.model';
import {EquipmentCapModel} from './equipment-cap.model';
import {LocationConnectionModel} from './location-connection.model';

export interface CableModel {
    id?: string;
    title?: string;
    sortOrder: number;
    equipmentInCapId?: string | null;
    equipmentOutCapId?: string | null;
    locationConnectionId: string;
    cableCores?: CableCoreModel[];
    created?: string;
    isActive: boolean;

    cableModelNo?: string | null;
    cableType?: string | null;
    cableManufacturer?: string | null;
    cableScreen?: boolean | null;
    cableAmour?: boolean | null;
    coreScreen?: boolean | null;
    cableCapacitancePerMeter?: number | null;
    cableCapacitance?: number | null;
    cableInductancePerMeter?: number | null;
    cableInductance?: number | null;
    cableLength?: number | null;

    equipmentInCap?: EquipmentCapModel;
    equipmentOutCap?: EquipmentCapModel;
    locationConnection: LocationConnectionModel;
}

export class CreateEditCableViewModel
    implements
        Omit<CableModel, 'id' | 'created' | 'isActive' | 'locationConnectionId' | 'cableCores' | 'equipmentInCap' | 'equipmentOutCap' | 'locationConnection'>
{
    id?: string;
    title?: string;
    sortOrder: number;
    equipmentInCapId?: string | null;
    equipmentOutCapId?: string | null;

    cableModelNo?: string | null;
    cableType?: string | null;
    cableManufacturer?: string | null;
    cableScreen?: boolean | null;
    cableAmour?: boolean | null;
    coreScreen?: boolean | null;
    connectedFromLocationId?: string;
    connectedToLocationId?: string;
    cableCapacitancePerMeter?: number | null;
    cableCapacitance?: number | null;
    cableInductancePerMeter?: number | null;
    cableInductance?: number | null;
    cableLength?: number | null;

    constructor(data?: CreateEditCableViewModel) {
        Object.assign(this, data);
    }
}

export interface UpdateCableSortOrderModel {
    dragedCableId: string;
    targetCableId: string;
    where: 'before' | 'after';
}
